import { Injectable, ViewChild } from '@angular/core';
import { ElectronService } from 'ngx-electron';
import { Subject } from 'rxjs/Subject';
import { Constants } from './models/constants';

@Injectable()
export class IS_ElectronService {
    private isBook = new Subject<any>();
    isBook$ = this.isBook.asObservable();

    public onBookPouchError = new Subject<any>();
    onBookPouchError$ = this.onBookPouchError.asObservable();

    private isExport = new Subject<any>();
    isExport$ = this.isExport.asObservable();

    private isExportBook = new Subject<any>();
    isExportBook$ = this.isExportBook.asObservable();

    private isShelfBook = new Subject<any>();
    isShelfBook$ = this.isShelfBook.asObservable();

    private downloadingPercent = new Subject<any>();
    downloadingPercent$ = this.downloadingPercent.asObservable();

    public IS_ELECTRON: boolean = false;
    public APP_PATH: String = '';
    public USER_PATH: String = '';
    public MEDIA_PATH: String = '';
    public THUMBS_PATH: String = '';
    public Export_Path: String = '';
    public APP_ASSETS_PATH: String = '';
    public APP_LQD_STA_PATH: String = '';
    public FS: any;
    public PATH: any;
    public extract: any;
    public ASSETS_PATH: String = '';
    public Book_Path: String = '';
    public request;
    public bookPdfName: String = '';
    public bookTemplates: any;
    public bookTemplateObj: any;
    public USER_ID;
    public MIME;
    public ZIP;
    public electronDialog;

    public downloadInProgress: boolean = false;
    public downloadingBooksArray = [];
    public current_bookObj;
    public current_bookDataObj;
    public storePouchServiceRef;
    public downloadEleServiceRef;


    constructor(private _electronService: ElectronService) {

        this.bookTemplates = Constants.getTemplates();

        this.IS_ELECTRON = this._electronService.isElectronApp;
        if (this._electronService.isElectronApp) {
            console.log("Electron Running");
            this.FS = this._electronService.remote.require('fs');
            this.PATH = this._electronService.remote.require('path');
            this.request = this._electronService.remote.require('request');
            this.extract = this._electronService.remote.require('extract-zip');
            this.MIME = this._electronService.remote.require('mime');
            // var currAppPath = this._electronService.remote.app.getAppPath() + '/src/assets/Nooor';
            var currAppPath = this._electronService.remote.app.getAppPath() + '/dist/assets/Nooor';
            var path = this._electronService.remote.app.getPath('userData');
            // this.APP_PATH = path;   
            this.APP_PATH = currAppPath;
            this.ZIP = this._electronService.remote.require('zip-folder');
            this.USER_PATH = this._electronService.remote.app.getAppPath() + '/dist/assets/Nooor/Default';
            this.electronDialog = this._electronService.remote.dialog;
            this.APP_ASSETS_PATH = this._electronService.remote.app.getAppPath() + '/dist/assets/';
            this.APP_LQD_STA_PATH = this._electronService.remote.app.getAppPath() + '/dist/assets/liquid_static';


        }
        else {
            console.log("Browser Running");
        }

    }
    ///////////////STORE BOOKS DOWNLOADING///////////////////////////

    storeBookDownload(book, storePouchServiceRef, downloadEleServiceRef) {
        this.storePouchServiceRef = storePouchServiceRef;
        this.downloadEleServiceRef = downloadEleServiceRef;
        if (book.zipUrl.length) {
            this.downloadingBooksArray.push(book);
        }
        else {
            return
        }
        if (!this.downloadInProgress) {
            // this.downloadBook(book);
            this.saveBookToPouch(book);
        }
    }

    saveBookToPouch(book) {

        var self = this;

        this.storePouchServiceRef.saveBookToPurchases(book).then((data) => {

            console.log("came in to saveBookToPurchases then");

            self.current_bookObj = data['bookObj'];
            self.current_bookDataObj = data['bookDataObj'];
            self.downloadBook(book);

        },
            (err) => {
                console.log("came in to saveBookToPurchases error");
                console.log(err);
                self.downloadingBooksArray.shift();
                self.manageDownloads();
                self.onBookPouchError.next(err);
            });

    }

    manageDownloads() {

        console.log("In manageDownloads");
        console.log(this.downloadingBooksArray);

        if (this.downloadingBooksArray.length) {
            let currBookObj = this.downloadingBooksArray[0];
            // this.downloadBook(currBookObj);
            this.saveBookToPouch(currBookObj);
        }
        else {
            this.downloadInProgress = false;
        }

    }

    downloadBook(book) {

        this.downloadInProgress = true;
        this.Book_Path = this.USER_PATH + '/' + book.publishId;
        if (!this.FS.existsSync(this.Book_Path)) {
            this.FS.mkdirSync(this.Book_Path);
            var url = book.zipUrl;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            var finalPath = this.Book_Path + "/" + filename;
            this.downloadZipFiles(url, finalPath, book);
        }
    }
    downloadBookCoverPage(url, bkId, book) {
        // var coverPath = this.APP_PATH + '/' + bkId;
        var coverPath = this.USER_PATH + '/' + bkId;
        var filename = url.substring(url.lastIndexOf('/') + 1);
        // var finalPath = coverPath + "/" + filename;
        var finalPath = coverPath + "/cover.png";
        this.downloadFile(url, finalPath, book);
    }
    downloadZipFiles(file_url, targetPath, book) {

        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;

        //if file_url throws error
        this.request(file_url, function (error, response, body) {
            console.log('error:', error); // Print the error if one occurred
            if (error != null) {
                console.log('error != null');
                _this.handleDownloads(book);
            }
        });


        var req = this.request({
            method: 'GET',
            url: file_url
        });
        var out = this.FS.createWriteStream(targetPath);
        req.pipe(out);

        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            _this.showProgress1(received_bytes, total_bytes, book);
        });
        req.on('end', function () {
            console.log("ZipFile succesfully downloaded");
            _this.extractZip(targetPath, _this.Book_Path, book);
        });
    }
    downloadFile(file_url, targetPath, book) {
        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;

        //if file_url throws error
        this.request(file_url, function (error, response, body) {
            console.log('error:', error); // Print the error if one occurred
            if (error != null) {
                console.log('error != null');
                _this.handleDownloads(book);
            }
        });

        var req = this.request({
            method: 'GET',
            url: file_url
        });

        var out = this.FS.createWriteStream(targetPath);
        req.pipe(out);

        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            _this.showProgress(received_bytes, total_bytes);
        });
        req.on('end', function () {
            console.log("File succesfully downloaded");
            _this.handleDownloads(book);
        });
    }

    handleDownloads(book) {

        //for test purpose
        if ((book.type == 'LIQUID' || book.type == "OLDELE") && book.publishId == this.current_bookObj.bId)
            this.downloadEleServiceRef.createPurchasedNewElessonBook(this.current_bookObj, this.current_bookDataObj);

        //
        this.downloadingBooksArray.shift();
        this.manageDownloads();
        this.isBook.next(book);

    }

    showProgress(received, total) {
        var percentage = (received * 100) / total;
        // console.log(percentage + "% | " + received + " bytes out of " + total + " bytes.");
    }

    showProgress1(received, total, book) {
        // console.log("In showProgress1");
        let downloadingPercentage = (received * 100) / total;
        let obj = {
            'book': book,
            'percent': Math.floor(downloadingPercentage)
        }
        this.downloadingPercent.next(obj);
    }

    extractZip(zipPath, targetPath, book) {
        var _this = this;
        this.extract(zipPath, { dir: targetPath }, function (err) {
            // extraction is complete. make sure to handle the err
            if (err) {
                console.log('Extraction Error');
            }
            else {
                console.log('Finished extracting');
                _this.FS.unlink(zipPath, (err) => {
                    if (err) {
                        console.log("cannot delete file", err);
                        return;
                    }
                    console.log("File succesfully deleted!");

                });

                if (book.thumbnailUrl.length > 0)
                    _this.downloadBookCoverPage(book.thumbnailUrl, book.publishId, book);
                else {
                    _this.handleDownloads(book);
                }

            }
        });
    }
    ///////////////////////////////////////////////////////////////////

    ///////////////////////EXPORT FUNCTIONALITY//////////////////////////
    downloadExportFile(file_url) {
        this.MEDIA_PATH = this.USER_PATH + '/Media';
        var targetPath = this.MEDIA_PATH + '/Export.zip';
        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;
        var req = this.request({
            method: 'GET',
            url: file_url
        });

        var out = this.FS.createWriteStream(targetPath);
        req.pipe(out);

        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            _this.showProgress(received_bytes, total_bytes);
        });
        req.on('end', function () {
            console.log("ExportFile succesfully downloaded");
            _this.extractExportZip(targetPath, _this.MEDIA_PATH);


        });
    }
    extractExportZip(zipPath, targetPath) {
        var _this = this;
        this.extract(zipPath, { dir: targetPath }, function (err) {
            // extraction is complete. make sure to handle the err
            if (err) {
                console.log('Extraction Error');
            }
            else {
                console.log('Finished extracting');
                _this.FS.unlink(zipPath, (err) => {
                    if (err) {
                        console.log("cannot delete file", err);
                        return;
                    }
                    console.log("File succesfully deleted!");

                });

            }
        });

    }

    convertZip() {
        var _this = this;
        var exportZipPath = this.USER_PATH;
        this.ZIP(this.USER_PATH + '/Export', exportZipPath + '/Export.zip', function (err) {
            if (err) {
                console.log('oh no!', err);
            } else {
                console.log('EXCELLENT');
                var delPath = _this.USER_PATH + '/Export';
                _this.deleteFolder(delPath);
                _this.isExport.next(true);
            }
        });
    }
    deleteFolder = function (path) {
        var _this = this;
        if (this.FS.existsSync(path)) {
            this.FS.readdirSync(path).forEach(function (file, index) {
                var curPath = path + "/" + file;
                if (_this.FS.lstatSync(curPath).isDirectory()) { // recurse
                    _this.deleteFolder(curPath);
                } else { // delete file
                    _this.FS.unlinkSync(curPath);
                }
            });
            this.FS.rmdirSync(path);
        }
    };
    insertPageAssetsintoExportFolder(assets) {
        this.Export_Path = this.USER_PATH + '/Export';
        this.MEDIA_PATH = this.USER_PATH + '/Media';
        this.THUMBS_PATH = this.USER_PATH + '/Thumbs';
        if (!this.FS.existsSync(this.Export_Path)) {
            this.FS.mkdirSync(this.Export_Path);
            assets.forEach(asset => {
                var filename = asset.split('/').pop();
                var targetPath = this.Export_Path + '/' + filename;
                var filePath = this.MEDIA_PATH + '/' + filename;
                if (this.FS.existsSync(filePath)) {
                    var rstream = this.FS.createReadStream(filePath);
                    var wstream = this.FS.createWriteStream(targetPath);
                    rstream.pipe(wstream);
                }
                else{
                filePath = this.THUMBS_PATH + '/' + filename;
                if (this.FS.existsSync(filePath)) {
                    var rstream = this.FS.createReadStream(filePath);
                    var wstream = this.FS.createWriteStream(targetPath);
                    rstream.pipe(wstream);
                }
                }
                
            });
            this.convertZip();
        }
    }

    exportBookDownload(book){      
        this.Book_Path = this.USER_PATH + '/' + book.bId;
        if (!this.FS.existsSync(this.Book_Path)) {
            this.FS.mkdirSync(this.Book_Path);
            var url = book.downloadUrl;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            var finalPath = this.Book_Path + "/" + filename;
            this.downloadExportBookZipUrl(url, finalPath,book);
        }
    }

    downloadExportBookZipUrl(file_url,targetPath,book) {
        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;
        var req = this.request({
            method: 'GET',
            url: file_url
        });

        var out = this.FS.createWriteStream(targetPath);
        req.pipe(out);

        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            _this.showProgress(received_bytes, total_bytes);
        });
        req.on('end', function () {
            console.log("File succesfully downloaded");        
            _this.extractExportBookZip(targetPath, _this.Book_Path,book);
        });
    }

    extractExportBookZip(zipPath, targetPath,book) {
        var _this = this;
        this.extract(zipPath, { dir: targetPath }, function (err) {
            // extraction is complete. make sure to handle the err
            if (err) {
                console.log('Extraction Error');
            }
            else {
                console.log('Finished extracting');
                _this.FS.unlink(zipPath, (err) => {
                    if (err) {
                        console.log("cannot delete file", err);
                        return;
                    }
                    console.log("File succesfully deleted!");

                });
                _this.downloadExportBookCoverPage(book.downloadThumbnailUrl,book.bId);
            
            }
        });
    }
    downloadExportBookCoverPage(url, bkId) {   
        var coverPath = this.USER_PATH + '/' + bkId;     
        var finalPath = coverPath + "/cover.png";
        this.downloadExportBookThumbFile(url, finalPath);
    }
    downloadExportBookThumbFile(file_url, targetPath) {
        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;
        var req = this.request({
            method: 'GET',
            url: file_url
        });

        var out = this.FS.createWriteStream(targetPath);
        req.pipe(out);

        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            _this.showProgress(received_bytes, total_bytes);
        });
        req.on('end', function () {
            console.log("File succesfully downloaded");            
            _this.isExportBook.next(true);
        });
    }

    //////////////////////////////////////

    ///////////////INSERT MEDIA FILES TO LOCAL FUNCTIONALITY////////////////////////////**

    insertFileintoMediaFolder(file, self) {
        var timestamp = Math.round(new Date().getTime() / 1000);
        var type = file.name.split('.')[1];
        var path = file.path;
        var targetPath = this.USER_PATH + '/Media/' + timestamp + '.' + type;
        var rstream = this.FS.createReadStream(path);
        var wstream = this.FS.createWriteStream(targetPath);
        rstream.pipe(wstream);
        if (localStorage.userData == 'undefined')
            var filePath = '../../assets/Nooor/Default/Media/' + timestamp + '.' + type;
        else
            var filePath = '../../assets/Nooor/' + this.USER_ID + '/Media/' + timestamp + '.' + type;

        if (self.imageAddedIntoDrive) {
            self.imageAddedIntoDrive(filePath);
        }

    }
    retrieveAllFilesInFolder(self, type) {
        let folderData = [];
        this.MEDIA_PATH = this.USER_PATH + '/Media';
        this.FS.readdir(this.MEDIA_PATH, (err, files) => {
            if (localStorage.userData == 'undefined')
                var commonPath = '../../assets/Nooor/Default/Media/';
            else
                var commonPath = '../../assets/Nooor/' + this.USER_ID + '/Media/';
            for (var i = 0; i < files.length; i++) {
                var filePath = this.MEDIA_PATH + '/' + files[i];
                var fileType = this.MIME.getType(filePath).split('/')[0];
                if (type == fileType) {
                    var path = commonPath + files[i];
                    var obj = { 'name': '', 'path': '' };
                    obj.path = path;
                    obj.name = files[i];
                    folderData.push(obj);
                }
            }
            console.log(folderData);
            self.getAllCloudFloderData(folderData);

        });

    }
    ////////////////////////////////////////////
    /////////////SHELF BOOK Download Functionality///////////////
    shelfBookDownload(book){      
        this.Book_Path = this.USER_PATH + '/' + book.bId;
        if (!this.FS.existsSync(this.Book_Path)) {
            this.FS.mkdirSync(this.Book_Path);
            var url = book.downloadUrl;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            var finalPath = this.Book_Path + "/" + filename;
            this.downloadShelftBookZipUrl(url, finalPath,book);
        }
    }

    downloadShelftBookZipUrl(file_url,targetPath,book) {
        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;
        var req = this.request({
            method: 'GET',
            url: file_url
        });

        var out = this.FS.createWriteStream(targetPath);
        req.pipe(out);

        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            _this.showProgress(received_bytes, total_bytes);
        });
        req.on('end', function () {
            console.log("File succesfully downloaded");        
            _this.extractShelfBookZip(targetPath, _this.Book_Path,book);
        });
    }

    extractShelfBookZip(zipPath, targetPath,book) {
        var _this = this;
        this.extract(zipPath, { dir: targetPath }, function (err) {
            // extraction is complete. make sure to handle the err
            if (err) {
                console.log('Extraction Error');
            }
            else {
                console.log('Finished extracting');
                _this.FS.unlink(zipPath, (err) => {
                    if (err) {
                        console.log("cannot delete file", err);
                        return;
                    }
                    console.log("File succesfully deleted!");

                });
                if (book.downloadThumbnailUrl.length > 0)
                    _this.downloadShelfBookCoverPage(book.downloadThumbnailUrl, book.bId);
                else {
                    _this.isShelfBook.next(true);
                }


            }
        });
    }
    downloadShelfBookCoverPage(url, bkId) {   
        var coverPath = this.USER_PATH + '/' + bkId;     
        var finalPath = coverPath + "/cover.png";
        this.downloadShelfBookThumbFile(url, finalPath);
    }
    downloadShelfBookThumbFile(file_url, targetPath) {
        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;
        var req = this.request({
            method: 'GET',
            url: file_url
        });

        var out = this.FS.createWriteStream(targetPath);
        req.pipe(out);

        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            _this.showProgress(received_bytes, total_bytes);
        });
        req.on('end', function () {
            console.log("File succesfully downloaded");            
            _this.isShelfBook.next(true);
        });
    }
    ///////////////////////////////////////////
    ////////////////LOGIN Functionality////////////
    createUserIdFolder(id) {
        this.USER_ID = id;
        this.USER_PATH = this.APP_PATH + '/' + id;
        if (!this.FS.existsSync(this.USER_PATH)) {
            this.FS.mkdirSync(this.USER_PATH);
        }
        this.MEDIA_PATH = this.USER_PATH + '/Media';
        this.THUMBS_PATH = this.USER_PATH + '/Thumbs';
        if (!this.FS.existsSync(this.MEDIA_PATH)) {
            this.FS.mkdirSync(this.MEDIA_PATH);
        }
        if (!this.FS.existsSync(this.THUMBS_PATH)) {
            this.FS.mkdirSync(this.THUMBS_PATH);
        }

    }
    clearUserData() {      
        var win = this._electronService.remote.getCurrentWindow();
        win.webContents.session.clearCache(function () {

        });
        // win.webContents.session.clearStorageData();
    }
    downloadeImport(file_url, targetPath) {
        var received_bytes = 0;
        var total_bytes = 0;
        var _this = this;
        var req = this.request({
            method: 'GET',
            url: file_url
        });

        var out = this.FS.createWriteStream(targetPath);


        req.on('response', function (data) {
            // Change the total bytes value to get progress later.
            total_bytes = parseInt(data.headers['content-length']);
        });
        req.on('data', function (chunk) {
            // Update the received bytes
            received_bytes += chunk.length;
            // _this.showProgress(received_bytes, total_bytes);
        });
        req.on('end', function () {
            console.log("File succesfully downloaded");
            // book.isDownloading = false;
            req.pipe(out)
                ;
            // book.downloaded = true;
            // _this.downloadingBooksArray.shift();
            // _this.manageDownloads();
            // _this.isBook.next(book);
        });
    }




}



//Reference
    // var bookTemplatesPath = this.APP_PATH + '/' + book.bId + '/Templates/' + book.templateId;
        // var mkdirp = this._electronService.remote.require('mkdirp');
        // var _this = this;
        // if (!this.FS.existsSync(bookTemplatesPath)){
        //     mkdirp(bookTemplatesPath, function (err) {
        //         if (err) console.error(err)
        //         else {
        //             console.log('Done!');
        //             this.downloadBookCoverPage(book.coverPage,book.bId);     
        //         }
        //     });
        //  }


// WEBPACK FOOTER //
// ./src/app/shared/IS_Electron.service.ts